// +----------------------------------------------------------------------
// | 「想想中」加载框：createDecision 是同步等 AI 分析完才跳结果页，
// | DeepSeek 一分析就是好几秒 —— 这期间没有反馈，用户会以为没点上，
// | 连点好几下（虽然有 submitting 挡着，但焦虑是真实的）。
// | 做法fixed半透明遮罩 + 居中小卡片：转圈 + 轮换的趣味文案，
// | 顺带把背后滚动锁住，从视觉到交互都明确「正在处理，稍等」。
// +----------------------------------------------------------------------
import { useEffect, useState } from 'react';
import './Thinking.less';

const TIPS = [
  '正在翻你过去的纠结……',
  '把选项掰开揉碎看看……',
  '想一想，别催……',
  '正在权衡利弊……',
  '快了快了，再憋个大招……',
];

export default function Thinking() {
  // 文案每 2 秒轮一次，从「别催」到「快了」有个时间递进感
  const [tip, setTip] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setTip((t) => (t + 1) % TIPS.length);
    }, 2000);
    // 遮罩出现期间锁住背后滚动
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      clearInterval(timer);
      document.body.style.overflow = prev;
    };
  }, []);

  return (
    <div className="thinking-mask" role="alert" aria-live="polite">
      <div className="thinking-card">
        <span className="thinking-spinner" />
        <p className="thinking-tip">{TIPS[tip]}</p>
      </div>
    </div>
  );
}
